var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileFacebook(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5500_71647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 21.7422C16.9327 21.7422 21.7422 16.9327 21.7422 11C21.7422 5.06725 16.9327 0.257812 11 0.257812C5.06725 0.257812 0.257812 5.06725 0.257812 11C0.257812 16.9327 5.06725 21.7422 11 21.7422Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M20.7835 15.4417C20.8098 15.3353 20.8539 15.2341 20.9139 15.1424C21.4623 13.8303 21.7439 12.4221 21.7422 11C21.7422 10.9231 21.7409 10.8466 21.7393 10.7701L14.7817 3.81254C14.1175 3.74208 13.4499 3.70795 12.782 3.71032C10.8031 3.71032 9.44877 4.91774 9.44877 7.13618V9.04919H7.21826V11.6488L9.44881 13.8789V18.2896L12.7574 21.5982C14.4975 21.3088 16.1397 20.596 17.5394 19.5223C18.939 18.4487 20.0531 17.0474 20.7835 15.4417Z",
    fill: "url(#paint0_linear_5500_71647)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.132 18.2896V11.6488H14.3707L14.7061 9.04919H12.132V7.39364C12.132 6.64276 12.3404 6.13113 13.4171 6.13113H14.7817V3.8125C14.1174 3.74208 13.4499 3.70797 12.7819 3.71032C10.8031 3.71032 9.44873 4.91774 9.44873 7.13617V9.04919H7.21826V11.6488H9.44881V18.2896H12.132Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5500_71647",
    x1: 8.01434,
    y1: 6.95021,
    x2: 24.3366,
    y2: 23.2725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369,
    stopColor: "#1D1D1B",
    stopOpacity: 0.856
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1D1D1B",
    stopOpacity: 0.429
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5500_71647"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileFacebook);
export default __webpack_public_path__ + "static/media/Profile_Facebook.a01b09c46223f55f6adf2fbb78199981.svg";
export { ForwardRef as ReactComponent };